import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, SxProps, Theme } from "@mui/material";
import { useState } from "react";

import { EventName, EventProps } from "@/shared/services/analytics";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

import { RobotoIconButton } from "./RobotoIconButton";
import { RobotoTooltip } from "./RobotoTooltip";

interface CopyToClipboardButtonProps {
  text: string;
  eventName?: EventName;
  eventProps?: EventProps<EventName>;
  sx?: SxProps<Theme>;
  className?: string;
  /** Names the button for assistive tech, e.g. "Copy session ID". */
  ariaLabel?: string;
}

const CopyToClipboardButton = ({
  text,
  eventName = "CopyLinkClicked",
  eventProps = { link: text },
  sx,
  className,
  ariaLabel,
}: CopyToClipboardButtonProps) => {
  const [copyMsg, setCopyMsg] = useState("Copy");

  return (
    <RobotoTooltip title={copyMsg}>
      <Box
        className={className}
        component="span"
        data-not-draggable="true"
        sx={sx}
      >
        <RobotoIconButton
          aria-label={ariaLabel}
          sx={{ padding: 0 }}
          eventName={eventName}
          eventProperties={eventProps}
          onClick={function copyText(event) {
            navigator.clipboard
              .writeText(text)
              .then(() => {
                setCopyMsg("Copied!");
              })
              .catch((e) => {
                setCopyMsg("Failed to copy!");
                ErrorMonitoringService.captureError(e);
              });
            event.stopPropagation();
          }}
          onBlur={() => setCopyMsg("Copy")}
        >
          <ContentCopyIcon sx={{ fontSize: "0.85rem" }} />
        </RobotoIconButton>
      </Box>
    </RobotoTooltip>
  );
};

export default CopyToClipboardButton;
